import React from 'react';
import './_header.scss';
import Navbar from 'react-bootstrap/lib/Navbar';
import Nav from 'react-bootstrap/lib/Nav';
import NavItem from 'react-bootstrap/lib/NavItem';
import UserContext from '../../UserContext';
import { Link } from 'react-router-dom';

export default function HeaderBar() {
  return (
    <UserContext.Consumer>
      {({ user }) => (
        <Navbar fluid={true} staticTop={true} className="header-bar">
          <Navbar.Header className="header-bar__nav-header">
            <Navbar.Brand className="header-bar__nav-brand">
              <Link to="/">
                <img
                  alt="Fusion Icon"
                  className="header-bar__nav-logo"
                  src={require('../../images/fusion-icon.png')}
                />
                Fusion - Welcome {user.name}
              </Link>
            </Navbar.Brand>
          </Navbar.Header>
          <Navbar.Collapse>
            <Nav pullRight>
              <NavItem
                eventKey={1}
                href="https://ghe.coxautoinc.com/CoxAuto-UI/fusion/tree/master/packages/fusion-starter"
              >
                <img
                  className="gitLogo"
                  alt="Github Logomark"
                  src={require('../../images/GitHub-Mark-Light-64px.png')}
                />
              </NavItem>
            </Nav>
          </Navbar.Collapse>
        </Navbar>
      )}
    </UserContext.Consumer>
  );
}



// WEBPACK FOOTER //
// ./src/components/Header/Header.js